import categories from 'src/config/categories.json'

const homeConstants = {
  categories: categories,

  liveSource: {
    type: 'video/mp4',
    src: 'https://d31apwikb2jjft.cloudfront.net/videos/f456fe4a-bcf9-4019-b556-3459258b6fb9-720', //'https://pubcmg.teleosmedia.com/linear/cmg/ga_statewide/playlist.m3u8',
  },
  liveThumbnailUrl: 'http://static.stringr.com/apps/web/ga_line/TheGaLineLiveThumbnail.png',
}

export default homeConstants
